<template>
  <modal-wrap :id="id" :name="modalName" :hide-footer="true" size="lg">
    <template #modal-title>
      <h4 class="mb-0">Create product</h4>
    </template>
    <form class="mt-3" @submit.prevent="handleSubmit">
      <div class="row g-3">
        <div class="col-12 col-md-3">
          <div class="form-group">
            <label for="inventory-product-sku">SKU *</label>
            <input
              id="inventory-product-sku"
              v-model="form.sku"
              type="text"
              class="form-control"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="col-12 col-md-9">
          <div class="form-group">
            <label for="inventory-product-name">Name *</label>
            <input
              id="inventory-product-name"
              v-model="form.name"
              type="text"
              class="form-control"
              autocomplete="off"
            />
          </div>
        </div>
      </div>
      <div class="mt-3 d-flex">
        <b-button type="submit" variant="success" class="btn-green flex-grow-1" :disabled="isSubmitDisabled">
          Create
        </b-button>
      </div>
    </form>
  </modal-wrap>
</template>

<script lang="ts">
import { BButton } from 'bootstrap-vue-next'
import { defineComponent, computed, onMounted, reactive } from 'vue'
import { CREATE_INVENTORY_PRODUCT } from '@/const/ModalTypes'
import { registerModals } from '@/services/Modal'
import { useInventoryStore } from '@/store/inventory'
import { useVueNextModalStore } from '@/store/vueNextModal'
import ModalWrap from '@/views/Modals/ModalWrap.vue'

export default defineComponent({
  name: 'CreateProductModal',
  components: { BButton, ModalWrap },
  props: {
    id: {
      type: String,
      required: true,
    },
    companyId: {
      type: String,
      default: undefined,
    },
  },
  emits: ['created'],
  setup(props, { emit }) {
    const modalName = CREATE_INVENTORY_PRODUCT
    const modalStore = useVueNextModalStore()
    const inventoryStore = useInventoryStore()
    const form = reactive({
      sku: '',
      name: '',
    })

    const isSubmitDisabled = computed(() => !props.companyId || !form.sku.trim() || !form.name.trim())

    const close = () => {
      modalStore.closeModal(modalName)
    }

    const reset = () => {
      form.sku = ''
      form.name = ''
    }

    const handleSubmit = async () => {
      if (isSubmitDisabled.value) return
      await inventoryStore.createProduct(props.companyId ?? '', { sku: form.sku.trim(), name: form.name.trim() })
      emit('created')
      reset()
      close()
    }

    onMounted(() => registerModals(modalName))

    return { modalName, form, isSubmitDisabled, handleSubmit }
  },
})
</script>
